import React from 'react';
const partners = [{
  name: 'Fatherhood Foundation of Virginia',
  logo: 'https://cdn.magicpatterns.com/uploads/m6E57sGjmmrpnH3eBi2HRt/FF_Logo2022_Red.png'
}, {
  name: 'Harrisonburg City Public Schools',
  logo: 'https://cdn.magicpatterns.com/uploads/3hEEMgs5SwXe9jWkNSzQSt/HCPS_OfficialFullLogoColorLight.jpg'
}, {
  name: 'Harrisonburg Downtown Renaissance',
  logo: 'https://cdn.magicpatterns.com/uploads/7cYeCTEGcjiLk91oUC9pEs/HDR_Logo.png.webp'
}, {
  name: 'Rockingham County Public Schools',
  logo: 'https://cdn.magicpatterns.com/uploads/wndka9hz7cePxUiPQeDgVE/RCPS-Logo.png'
}];
export function PartnersSection() {
  return <section className="py-16 bg-white" data-id="element-155" data-mp="3docj73uq5ulu">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-156" data-mp="3dnb3un6oelyb">
        <h2 className="text-2xl md:text-3xl font-bold text-[#1a1a1a] mb-10" data-id="element-157" data-mp="xwox63h91mht">
          Thank You to Our Partners
        </h2>

        {/* Carousel container */}
        <div className="relative overflow-hidden" data-id="element-158" data-mp="t07yifcfbpqh">
          <div className="flex animate-scroll" data-id="element-159" data-mp="1k6ehb0g35ogw">
            {/* First set of logos */}
            {partners.map((partner, index) => <div key={`first-${index}`} className="flex-shrink-0 mx-8 md:mx-12 flex items-center justify-center" data-id="element-160" data-mp="1o788q3sqllej" data-mpi={index}>
                <img src={partner.logo} alt={partner.name} className="h-16 md:h-20 w-auto object-contain" data-id="element-161" data-mp="1y6649qokyf71" />
              </div>)}
            {/* Duplicate set for seamless loop */}
            {partners.map((partner, index) => <div key={`second-${index}`} className="flex-shrink-0 mx-8 md:mx-12 flex items-center justify-center" data-id="element-162" data-mp="1agv0s1fui6p7" data-mpi={index}>
                <img src={partner.logo} alt={partner.name} className="h-16 md:h-20 w-auto object-contain" data-id="element-163" data-mp="hthagm6nk9e2" />
              </div>)}
          </div>
        </div>
      </div>

      <style data-id="element-164" data-mp="epjlf16mfp0q">{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          animation: scroll 25s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>;
}